export default __webpack_public_path__ + "static/media/bell-tone.68f78a7f.mp3";